import React from "react";
import { FashionHeader } from "@/components/FashionHeader";
import { FashionFooter } from "@/components/FashionFooter";

export function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen" style={{ background: "var(--fashion-bg)" }}>
      <FashionHeader />
      <main className="flex-1">{children}</main>
      <FashionFooter />
    </div>
  );
}
